export default __webpack_public_path__ + "static/media/ExampleAuth.6ed113e0.png";